import Head from 'next/head'
import shopInfos from 'template/infos'
const { name, url } = shopInfos
const title = `Designmöbel-Marken online kaufen | ${name}`
const description = 'Entdecken Sie kuratierte Möbel-, Design- und Interior-Marken im Überblick und finden Sie hochwertige Produkte für Wohnräume, Büro und Einrichtung.'

const Seo: React.FC = () => <Head>

  <title>{title}</title>

  <meta name='description' content={description} />

  <link rel='canonical' href={`${url}brands`} />

</Head>

export default Seo
